import React, { Fragment } from 'react';

const GenericModal = ({ modalLink, modalText }) => {
    return (
        <Fragment>
            <div className="custom-modal__link-wrapper" onClick={() => genericModal.showModal()}>
                <span className="custom-modal__link">{modalLink}</span>
            </div>
            <dialog id="genericModal" className="custom-modal custom-modal__no-gap custom-modal__generic-modal">
                <form method="dialog">
                    <div className="custom-modal__container">
                        <button onClick={() => genericModal.close()} className="custom-modal__close">
                            <i className="fa fa-circle-xmark"></i>
                        </button>
                        <div dangerouslySetInnerHTML={{ __html: modalText }}></div>
                    </div>
                </form>
            </dialog>
        </Fragment>
    );
};

export default GenericModal;